/**
 * Rounds a price up to the nearest 0.50 increment or upper whole number (0.00, 0.50, 1.00, 1.50, 2.00, etc.)
 * This ensures all insurance policy prices conform to the allowed decimal increments.
 * 
 * Examples:
 * - 243.33 -> 243.50
 * - 243.10 -> 243.50
 * - 243.76 -> 244.00
 * - 243.50 -> 243.50 (already valid)
 * - 100.00 -> 100.00 (already valid)
 * 
 * @param {number} price - The price to round
 * @returns {number} - The rounded price
 */
export function roundUpToQuarter(price) {
  if (typeof price !== 'number' || isNaN(price)) {
    return 0;
  }
  
  // Multiply by 2 to convert 0.50 increments to whole numbers, round up, then divide by 2
  return Math.ceil(price * 2) / 2;
}

/**
 * Rounds a price up to the nearest 0.25 increment and formats it to 2 decimal places
 * 
 * @param {number} price - The price to round
 * @returns {string} - The rounded price formatted to 2 decimal places
 */
export function roundUpToQuarterFormatted(price) {
  return roundUpToQuarter(price).toFixed(2);
}

